// config
import * as http from 'utils/http';
import config from 'config';

const updateCarrierUser = async ({ carrierUserDto, carrierUserId }) => {
  return http.patch(`${config.BASE_ROUTE}api/users/${carrierUserId}/`, carrierUserDto);
};

export default updateCarrierUser;
